import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/nav";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-[72px] flex items-center justify-between gap-4">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            setMenuOpen(false);
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-2 cursor-pointer shrink-0"
          aria-label="5.1吃瓜 首页"
        >
          <span
            className={`w-9 h-9 flex items-center justify-center rounded-md text-lg ${
              scrolled || menuOpen
                ? "bg-primary-500 text-background-50"
                : "bg-background-50/90 text-primary-600"
            }`}
          >
            <i className="ri-fire-fill" />
          </span>
          <span className="leading-none">
            <span
              className={`block font-heading font-bold text-lg md:text-xl ${
                scrolled || menuOpen ? "text-foreground-950" : "text-background-50"
              }`}
            >
              5.1吃瓜
            </span>
            <span
              className={`block text-[11px] tracking-widest mt-0.5 ${
                scrolled || menuOpen ? "text-foreground-600" : "text-background-100/80"
              }`}
            >
              娱乐事件盘点
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1 flex-1 justify-center" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              onClick={(e) => {
                e.preventDefault();
                scrollTo(link.id);
              }}
              className={`px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                  : "text-background-50/90 hover:text-background-50 hover:bg-background-50/15"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 shrink-0">
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              scrollTo("contact");
            }}
            className="hidden sm:inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
          >
            <i className="ri-send-plane-line" />
            我要爆料
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-xl cursor-pointer transition-colors ${
              scrolled || menuOpen
                ? "text-foreground-900 hover:bg-background-100"
                : "text-background-50 hover:bg-background-50/15"
            }`}
          >
            <i className={menuOpen ? "ri-close-line" : "ri-menu-line"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav
          className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3"
          aria-label="移动端导航"
        >
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo(link.id);
                }}
                className="py-3 px-2 text-sm text-foreground-800 border-b border-background-100 last:border-b-0 cursor-pointer hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                scrollTo("contact");
              }}
              className="mt-3 py-2.5 px-3 rounded-md text-sm font-medium text-center bg-primary-500 text-background-50 cursor-pointer"
            >
              我要爆料
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}